export default __webpack_public_path__ + "static/media/page-not-found.022c4dd9.svg";